import { useLanguage } from "hooks";
import { useEffect } from "react";

import styles from "./CookiePolicyScreen.module.scss";

const COOKIE_POLICY_ID = "CookiePolicy";

export const CookiePolicyScreen = () => {
  const language = useLanguage();
  const dataCulture = language.toUpperCase();

  useEffect(() => {
    const dataCultureAttr = document
      .getElementById(COOKIE_POLICY_ID)
      ?.getAttribute("data-culture");

    if (dataCultureAttr !== dataCulture) {
      document
        .getElementById(COOKIE_POLICY_ID)
        ?.setAttribute("data-culture", dataCulture);
    }
  }, [dataCulture]);

  return (
    <div className={styles.container}>
      <script
        id={COOKIE_POLICY_ID}
        data-culture={dataCulture}
        src="https://policy.app.cookieinformation.com/cid.js"
        type="text/javascript"
        defer
      />
    </div>
  );
};

export default CookiePolicyScreen;
